var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire","full-width":""}},_vm._l((_vm.items),function(item){return _c('span',{key:item.userid},[_c('working-dues-report-letter',{attrs:{"item":item,"year":_vm.year}}),_vm._v(" "),_c('working-dues-tax-stub',{key:item.userid,attrs:{"item":item,"year":_vm.year}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }